module.exports = __webpack_public_path__ + "static/digipay-sss-pagibig-banner-2ce60bebd37bb6e219d97629842211e9.jpg";